import { useState, useCallback } from "react";
import { useFileReader } from "./useFileReader";
import useApi from "./useApi";
import { createBulkStudents, updateBulkStudents } from "../services/StudentService";

export default function useBulkUpload(programData, isUpdate = false) {
  const { readExcel } = useFileReader(programData);
  const [fileData, setFileData] = useState(null);

  const { execute: uploadBulk, loading } = useApi(
    isUpdate ? updateBulkStudents : createBulkStudents
  );

  const handleFile = useCallback((file) => {
    readExcel(file, setFileData);
  }, [readExcel]);

  const submitBulkUpload = useCallback(async () => {
    if (!fileData) return;
    await uploadBulk({ file: fileData });
  }, [fileData, uploadBulk]);

  return {
    fileData,
    handleFile,
    submitBulkUpload,
    loading
  };
}
